<template>
  <div>
    <topbar />
    <div class="wrapper-index">
      <header1 />
      <div class="content">
        <line1 />
        <line11 />
        <line2 />
        <line3 />
        <line4 />
      </div>
      <!-- <rightBar /> -->
    </div>
  </div>
</template>

<script>
import '../assets/css/index.css'
import topbar from '../components/common/topbar'
import header1 from '../components/common/header'
import line1 from '../components/index/line1'
import line11 from '../components/index/line11'
import line2 from '../components/index/line2'
import line3 from '../components/index/line3'
import line4 from '../components/index/line4'
// import rightBar from '../components/index/rightbar'
export default {
  components: { topbar, header1, line1, line2, line3, line4, line11 }
}
</script>



// WEBPACK FOOTER //
// src/views/index.vue